// node modules
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
// actions
import { getCheckoutArchiveDetails } from '../../../redux/checkouts/archives/actions';
// Components
import Spin from '../../../components/loading';
import { enumHelper } from '../../../utils';
import ENUMS from '../../../enums/index';

function DetailsCheckoutArchiveModal(props) {
  const dispatch = useDispatch();
  const state = useSelector(state => state.checkoutsArchiveReducer);

  // functions :
  const closeModal = () => {
    props.setShowModal('');
  };

  useEffect(() => {
    dispatch(getCheckoutArchiveDetails(props.selectedRecordId));
  }, []);

  return (
    <Modal isOpen={props.showDetailsModal === 'details'} size='xl'>
      <ModalHeader>
          <span className='modal-title'>
            ‍‍‍‍‍{`جزییات ${props.selectedCafeName}`}
          </span>
        <span
          title={locales('labels.close.modal')}
          className='modal-close'
          onClick={closeModal}
        >
            close
          </span>
      </ModalHeader>
      <ModalBody>
        <Spin
          spinning={state.getCheckoutArchiveDetailsLoading}
        >
          {
            state.getCheckoutArchiveDetailsError ? (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            ) : (
              <div className='container'>
                {state.getCheckoutArchiveDetailsFailed &&
                <div className='alert alert-danger'>{state.getCheckoutArchiveDetailsMessage}</div>}
              </div>
            )}
        </Spin>

        <div className="col-12 border rounded py-2 px-4">
          <div className="col-12 d-flex p-0">
            <div className="col-4 d-flex p-0">
              <div className="col-6">{locales('messages.cafeName')}</div>
              <div className="col-6 text-dark font-weight-bold">{props.selectedCafeName}</div>
            </div>
            <div className="col-4 d-flex p-0">
              <div className="col-6">{locales('tables.createdAt')}</div>
              <div className="col-6 text-dark font-weight-bold">{state.checkoutArchiveDetails.createdAt}</div>
            </div>
            <div className="col-4 d-flex p-0">
              <div className="col-6">{locales('titles.reservesCount')}</div>
              <div className="col-6 text-dark font-weight-bold">{state.checkoutArchiveDetails.reservesCount}</div>
            </div>
          </div>

          <hr/>

          <div className="col-12 d-flex p-0 py-2">
            <div className="col-2">{locales('fields.checkout.paidAt')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">{state.checkoutArchiveDetails.checkoutAt}</div>
            <div className="col-2">{locales('fields.checkout.sourceBankName')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">{state.checkoutArchiveDetails.sourceBankName}</div>
            <div className="col-2">{locales('fields.checkout.destinationBankName')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">{state.checkoutArchiveDetails.destinationBankName}</div>
          </div>

          <hr/>

          <div className="col-12 d-flex p-0 py-2">
            <div className="col-2">{locales('fields.checkout.payerName')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">{state.checkoutArchiveDetails.payerName}</div>
            <div className="col-2">{locales('fields.checkout.payType')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">
              {enumHelper.convertEnumValueToTitle(ENUMS.PAY_TYPES.list, state.checkoutArchiveDetails.payType) || '---'}
            </div>
            {state.checkoutArchiveDetails.payType === 'CARD' &&
            <>
              <div className="col-2">{locales('fields.card.number')}</div>
              <div
                className="col-2 text-dark font-weight-bold">{state.checkoutArchiveDetails.payTypeValue}</div>
            </>
            }
            {state.checkoutArchiveDetails.payType === 'CHECK' &&
            <>
              <div className="col-2">{locales('fields.check.number')}</div>
              <div
                className="col-2 text-dark font-weight-bold">{state.checkoutArchiveDetails.payTypeValue}</div>
            </>
            }
            {state.checkoutArchiveDetails.payType === 'CASH_TRANSFER' &&
            <>
              <div className="col-2">{locales('fields.account.number')}</div>
              <div
                className="col-2 text-dark font-weight-bold ">{state.checkoutArchiveDetails.payTypeValue}</div>
            </>
            }
          </div>
          <hr/>
          <div className="col-12 d-flex p-0 py-2">
            <div className="col-2">{locales('fields.checkout.sumRseeStockAmount')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">{Number(state.checkoutArchiveDetails.sumRseeStockAmount).toLocaleString()}</div>
            <div className="col-2">{locales('fields.checkout.minCheckout')}</div>
            <div
              className="col-2 d-flex text-dark font-weight-bold flex-wrap">{Number(state.checkoutArchiveDetails.minCheckout).toLocaleString()}</div>
            <div className="col-2">{locales('fields.checkout.balance')}</div>
            <div
              className="col-1 d-flex text-dark font-weight-bold flex-wrap direction-ltr">{Number(state.checkoutArchiveDetails.balance).toLocaleString()}</div>
          </div>

          <hr/>
          <div className="col-12 d-flex p-0 py-2">
          <div className="col-2">{locales('fields.checkout.sumBaseCost')}</div>
          <div
            className="col-2 d-flex text-dark font-weight-bold flex-wrap">{Number(state.checkoutArchiveDetails.sumBaseCost).toLocaleString()}</div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className='btn btn-light mx-1'
          onClick={closeModal}
          disabled={state.loading}
        >
          {locales('labels.close.modal')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default DetailsCheckoutArchiveModal;
